import BusinessModelCard from './BusinessModelCard';

export default BusinessModelCard;
